import React from 'react';
import { Card, CardBody } from '@heroui/react';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';
import { useTranslation } from 'react-i18next';

interface ContentStatCardProps {
  title: string;
  count: number;
  change: number;
  icon: string;
  color: string;
}

export const ContentStatCard: React.FC<ContentStatCardProps> = ({ 
  title, 
  count, 
  change, 
  icon, 
  color 
}) => {
  const { t } = useTranslation();
  
  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.3 } }
  };

  return (
    <motion.div variants={item} initial="hidden" animate="show">
      <Card className="overflow-visible">
        <CardBody className="p-4">
          <div className="flex items-center gap-3">
            <div className={`p-3 rounded-lg ${color}`}>
              <Icon icon={icon} width={20} />
            </div>
            <div>
              <p className="text-gray-500 text-xs">{title}</p>
              <div className="flex items-center gap-2">
                <h3 className="text-lg font-semibold">
                  <CountUp end={count} duration={2} separator="," />
                </h3>
                <span className={`text-xs ${change >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                  {change > 0 && '+'}{change}%
                </span>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </motion.div>
  );
};